export enum ActionTypeEnum {
  sendConversation = 'send-conversation',
}
